/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BodyCreateSession } from '../../models/body-create-session';
import { Session } from '../../models/session';

export interface CreateSession$Params {
      body: BodyCreateSession
}

export function createSession(http: HttpClient, rootUrl: string, params: CreateSession$Params, context?: HttpContext): Observable<StrictHttpResponse<Session>> {
  const rb = new RequestBuilder(rootUrl, createSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Session>;
    })
  );
}

createSession.PATH = '/sessions';
